import Config from './config'

const production = {
  isLocal: false,
  isProduction: true,
  apiBase: '/api/',
  formPost: '/index.php?p=actions%2Fdolphiq-craft3-forms%2Fmain%2Findex&handle=',
}

const stage = {
  ...production,
  isLocal: true,
  isProduction: false,
}

const dev = {
  ...production,
  isLocal: true,
  isProduction: false,
  apiBase: '/api/',
}

// initialize config
Config.default(production)
  .environment(/stage/, { ...stage })
  .environment(/bryandev/, { ...dev })
  .environment(/joshdev/, { ...dev })
  .environment(/savanadev/, { ...dev })
  .environment(/lauradev/, { ...dev })
  .environment(/localhost/, { ...dev })
  .detect()

export default Config
